module.exports = __webpack_public_path__ + "static/media/photo-15.e8ada4cc.webp";